var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item_media item_html" }, [
    _c("iframe", {
      ref: "htmlFrame",
      attrs: {
        id: "entrance_intro",
        title: "카페 대문 - html",
        width: "100%",
        height: "400",
        frameborder: "0",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }